import { twMerge } from 'tailwind-merge';
import { ProductCardProps } from '../../types';
import { CheckboxOutline, CheckboxFilled } from '@weee-fe/kunlunicon';
import { commonClickExtend } from '@/tracks/useClickActionT2';
import { usePersonalizedCoupon } from '@/store/personalized-coupon';
import { useMemo } from 'react';
import { formatPercentageCouponValue, formatPersonalizedDiscountCopy } from '../../helper/product-target-coupon';
import useGetTargetProductCouponInfo from '../../hook/useGetTargetProductCouponInfo';

export default function CardBodyProductClaimed(props: Partial<ProductCardProps>) {
  const { data, className, positionInfoT2 } = props;
  const { claimPersonalizedCoupon } = usePersonalizedCoupon();
  const { show, claimed, subtraction, personalizedDiscount } = useGetTargetProductCouponInfo(props);

  const displayCopy = useMemo(() => formatPersonalizedDiscountCopy(personalizedDiscount, Number(data?.price)), [
    personalizedDiscount,
    data?.price
  ]);

  const handleClick = async (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (claimed) return;
    const productId = Number(data?.id);
    if (!Number.isFinite(productId)) return;
    await claimPersonalizedCoupon(productId);
    commonClickExtend({
      ...positionInfoT2.modSecPos,
      co: {
        target_nm:
          subtraction?.type === 'D'
            ? subtraction?.reduce
            : formatPercentageCouponValue(subtraction?.percentage, Number(data?.price)),
        target_type: `coupon_${subtraction?.type}`,
        target_pos: positionInfoT2?.prodPos || 0,
        click_type: 'normal',
        is_select: true
      },
      ctx: {
        tag_id: data?.id
      }
    });
  };

  if (!show) return null;

  return (
    <div className={twMerge('flex items-center gap-1', className)} onClick={handleClick}>
      <div className={`w-[14px] h-[14px] rounded-sm border flex items-center justify-center enki-body-xs`}>
        {claimed ? (
          <CheckboxFilled className="text-tertiary-base-2" />
        ) : (
          <CheckboxOutline className="text-shade-neutral-base-1" />
        )}
      </div>
      <div className="text-tertiary-base-2 enki-body-2xs-medium">{displayCopy}</div>
    </div>
  );
}
